import { actions } from 'react/api/actions/dashboardAnalytics';
import { fromJS } from 'immutable';

const initialState = fromJS({
  tokens: {
    analyticsToken: '',
  },
  isServiceUp: null
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.setAnalyticsToken:
      return state.setIn(['tokens', 'analyticsToken'], action.payload);
    case actions.setAnalyticsHealth:
      return state.set('isServiceUp', action.payload);
    default:
      return state;
  }
};
